export enum Forms {
  enterForm = 'enterForm',
  loginForm = 'loginForm',
  registrationOrRecoveryForm = 'registrationOrRecoveryForm',
  recoveryByEmailForm = 'recoveryByEmailForm',
  pinCodeAuthenticationForm = 'authenticationForm',
  phoneNumberCheckForm = 'phoneNumberCheckForm',
  changeParameter = 'changeParameterForm',
  changePassword = 'changePasswordForm',
  confirmPhoneForm = 'confirmPhoneForm',
  confirmEmailForm = 'confirmEmailForm',
  desktopSettings = 'desktopSettings',
  visuallyImpaired = 'visuallyImpaired',
  showRequest = 'showRequestForm',
  createRequest = 'createRequest',
  pollForm = 'pollForm',
  applicationsFilterForm = 'applicationsFilterForm',
  newsFilter = 'newsFilter',
  acceptorsFilterForm = 'acceptorsFilterForm',
  citySearchForm = 'citySearchForm',
}
